import { Injectable, OnInit, Output } from "@angular/core";
import { Observable, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { LocationsAPIService } from "../../shared/services/API/LocationsAPI.service";
@Injectable({
  providedIn: "root",
})
export class LocationsService implements OnInit {
  
  setLocationsGeoJsonFilter_Subsbcription: Subscription;
  getGeoJsonAvailabilityFilter_Subsbcription: Subscription;
 
  DataGeoJson$: Subject<EstatusJSON> = new Subject<EstatusJSON>();

  private isLoading: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();
  
  constructor(private locationService: LocationsAPIService) {
  }

  ngOnInit() {
    
  }

  
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }


 
  recalculateCoordsProcess() {
    return this.locationService.recalculateCoordsProcess();
  }

  GetLayerGPSGeoJson(){
    return this.locationService.GetLayerGPSGeoJson();
  }

  GetLayerByIdLocationCategoryGeoJSON( IdLocationCategory : number){
    return this.locationService.GetLayerByIdLocationCategoryGeoJSON(IdLocationCategory);
  }

  setLocationsGeoJsonFilter(filters: any):any{
    this.setLocationsGeoJsonFilter_Subsbcription = this.locationService.setLocationsGeoJsonFilter(filters).subscribe((data)=>{
      this.DataGeoJson$.next(data);
      this.setLocationsGeoJsonFilter_Subsbcription.unsubscribe();
    });
    return this.DataGeoJson$.asObservable();
  }

  GetGeoJsonAvailabilityFilter(filters: any, initialDate: string, finalDate: string, idLocationCategories: number[]):any{
    this.getGeoJsonAvailabilityFilter_Subsbcription = this.locationService.GetGeoJsonAvailabilityFilter(filters, initialDate, finalDate, idLocationCategories).subscribe((data)=>{
      this.DataGeoJson$.next(data);
      this.getGeoJsonAvailabilityFilter_Subsbcription.unsubscribe();
    });
    return this.DataGeoJson$.asObservable();
  }

  getByIdentifier(identifier): any {
    return this.locationService.getByIdentifier(identifier);
  }
  postValidateIdentifiers(identifiers: string[], client: string = ""): any {
    return this.locationService.postValidateIdentifiers(identifiers, client);
  }

  getLastOdometer(identifier): any {
    return this.locationService.getLastOdometer(identifier);
  }

  updateLocationOdometer( identifier, kilometraje: number): any {
     return this.locationService.updateLocationOdometer(identifier, kilometraje);
  }

  getDataNames(keyNames: any) {
    return this.locationService.getDataNames(keyNames);
  }

  getListByGroups( customerGroups: any ): any {
    return this.locationService.getListByGroups(customerGroups);
  }

  CreateOrUpdateLocationProperty(identifier: string, keyName: string, keyValue: string): any {
    return this.locationService.CreateOrUpdateLocationProperty(identifier, keyName, keyValue);
  }

  getList(): any {
    return this.locationService.getList();
  }

  getByClientList(client: string, groupList = "", subGroupList = ""): any {
    return this.locationService.getByClientList(client, groupList, subGroupList);
  }

  findByIdentifier(identifier): any {
    return this.locationService.findByIdentifier(identifier);
  }

  postLocationsTabToExcel(selectedTab: string, idLocationCategory: number, finder: string, filtersRequest : any[]): any {
    return this.locationService.postLocationsTabToExcel(selectedTab, idLocationCategory, finder, filtersRequest);
  }

  postLocationsVinListToExcel(listaVin: any[]): any {
    return this.locationService.postLocationsVinListToExcel(listaVin);
  }

  findUpdatedByIdentifier(identifier, tipo): any {
    return this.locationService.findUpdatedByIdentifier(identifier, tipo);
  }

  FindAllByIdentifier(identifier): any {
    return this.locationService.FindAllByIdentifier(identifier);
  }

  getListFilter(filtersRequest : any[]): any {
     return this.locationService.getListFilter(filtersRequest);
  }

  getListFilterTab(filtersRequest : any[], tipoTab: string, finder: string, idLocationCategory: number): any {
     return this.locationService.getListFilterTab(filtersRequest, tipoTab, finder, idLocationCategory);
  }

  GetCountListActualizados(filters: any[]): any {
    return this.locationService.GetCountListActualizados(filters);
  }

  GetCountListDesactualizados(filters: any[]): any {
    return this.locationService.GetCountListDesactualizados(filters);
  }

  GetCountListSinReporte(filters: any[]): any {
    return this.locationService.GetCountListSinReporte(filters);
  }

  GetCountByIdLocationCategory(idLocationCategory:number, filters: any[]) {
    return this.locationService.GetCountByIdLocationCategory(idLocationCategory,filters);
  }

  GetListDesactualizados(): any {
    return this.locationService.GetListDesactualizados();
  }
  GetListByIdLocationCategory(idLocationCategory: number): any {
    return this.locationService.GetListByIdLocationCategory(idLocationCategory);
  }
  
  GetListActualizadosPage(page:number): any {
    return this.locationService.GetListActualizadosPage(page);
  }

  GetListDesactualizadosPage(page:number): any {
    return this.locationService.GetListDesactualizadosPage(page);
  }

  GetListSinReportePage(page:number): any {
    return this.locationService.GetListSinReportePage(page);
  }

  GetListByIdLocationCategoryPage(idLocationCategory: number, page:number): any {
    return this.locationService.GetListByIdLocationCategoryPage(idLocationCategory, page);
  }

  GetRouteSheet(parentIdentifier: string, idLocationCategoryChild: number, filter: string, includeGeojson: boolean, orderValue: boolean, isForcedReload: boolean):any{
    return this.locationService.GetRouteSheet(parentIdentifier, idLocationCategoryChild, filter, includeGeojson, orderValue, isForcedReload);
  }

  GetRouteSheetPage(parentIdentifier: string, idLocationCategoryChild: number, filter: string, includeGeojson: boolean, orderValue: boolean, isForcedReload: boolean, page: number):any{
    return this.locationService.GetRouteSheetPage(parentIdentifier, idLocationCategoryChild, filter, includeGeojson, orderValue, isForcedReload, page);
  }
}
